<template>
	<section class="advices">
		<ul>
			<li v-for="(advice, i) in advices" :key="`advice_${i}`" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
				<router-link :to="(currentLanguage + advice.permalink) | clearUrl">
					<span class="icon">
						<IconCircle />
						{{ advice.lang }}
					</span>
					<span class="text">
						{{ advice.title }}
					</span>
				</router-link>
			</li>
		</ul>
	</section>
</template>

<script>
import { mapState } from "vuex";
import IconCircle from "@/components/icons/IconCircle";
import EventBus from "@/helpers/event-bus";

export default {
	name: "AdvicesList",
	components: {
		IconCircle,
	},
	computed: {
		...mapState({
			advices: (state) => state.advices.advices,
			currentLanguage: (state) => {
				const lang = state.site.currentLanguage != state.site.defaultLanguage ? "/" + state.site.currentLanguage : "";

				return lang;
			},
		}),
	},
	created() {
		this.$store.dispatch("advices/getAll");
	},
	methods: {
		onMouseEnter(ev) {
			const parent = ev.currentTarget;
			const icon = this.grabIcon(ev);
			EventBus.$emit(EventBus.pointer.enter, { el: icon, parent, type: "lang" });
		},
		onMouseLeave(ev) {
			const parent = ev.currentTarget;
			const icon = this.grabIcon(ev);
			EventBus.$emit(EventBus.pointer.leave, { el: icon, parent });
		},
		grabIcon(ev) {
			const el = ev.currentTarget;
			const icon = el.getElementsByTagName("span")[0];

			return icon;
		},
	},
};
</script>

<style lang="scss" scoped>
section.advices {
	text-align: left;

	@include mq($from: m) {
		// text-align: center;
	}
}

ul {
	list-style: none;
	margin: 0;
	padding: 0;
	text-align: left;
	display: inline-block;

	li {
		&:first-child {
			a {
				margin-top: 0;
			}
		}
	}

	// li:first-child {
	//   a {
	//     margin-top: 0;
	//   }
	// }

	a {
		@include fontLanguage();
		position: relative;
		text-decoration: underline;
		// @include linkUnderline();
		display: inline-block;
		padding-left: 36px;

		span.text {
			line-height: inherit;
			@include textUnderlineGradient;
		}

		span.icon {
			// @include fontCopyS;
			font-family: "Barlow Condensed", sans-serif;
			font-size: 14px;
			font-weight: 500;
			position: absolute;
			top: 50%;
			left: 0;
			transform: translate(0, -40%);
			padding: 5px;
			width: 32px;
			text-align: center;

			svg {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				width: 100%;
			}
		}

		&:hover {
			span.text {
				@include textUnderlineGradientHover;
			}
		}
	}
}
</style>
